import type { TrackEvent, TrackerProvider, TrackContextPayload } from './types';

const providers: TrackerProvider[] = [];

export function registerTrackerProvider(provider: TrackerProvider): void {
  if (!providers.find(p => p.name === provider.name)) {
    providers.push(provider);
  }
}

export function clearTrackerProviders(): void {
  providers.length = 0;
}

export function track(event: TrackEvent): void {
  for (const provider of providers) {
    try {
      provider.track(event);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`[tracking] provider "${provider.name}" failed`, error);
    }
  }
}

export function setTrackingUser(userId: string | null): void {
  for (const provider of providers) {
    try {
      provider.setUser?.(userId);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        `[tracking] provider "${provider.name}" setUser failed`,
        error
      );
    }
  }
}

export function trackScreenView(
  screenName: string,
  payload?: TrackContextPayload
): void {
  for (const provider of providers) {
    try {
      provider.screen?.(screenName, payload);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        `[tracking] provider "${provider.name}" screen failed`,
        error
      );
    }
  }
}

export type {
  TrackEvent,
  TrackerProvider,
  TrackContextPayload,
  TrackScreenName,
  TrackEventType,
} from './types';
